module.exports = __webpack_public_path__ + "img/image-home.5b386164.jpg";